module.exports = {"0":{"background":"black","logoLarge":"moneyroad_white_green.png","logoMiddle":"mrlogo.png"}}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/companyTheme.json
// module id = 2955
// module chunks = 2